import React from "react";

const Input = ({ placeholder, isservice, type, icon, ...rest }) => {
  return (
    <div className={`flex items-center w-full px-5 py-4 justify-between border border-troo-primary border-opacity-20 rounded bg-troo-white `}>
      <input
        type={type}
        placeholder={placeholder}
        {...rest}
        className={` bg-transparent outline-none w-full placeholder-troo-black `}
      />
      <div className={` text-xl cursor-pointer `}>{icon}</div>
    </div>
  );
};

export default Input;
